import axios from 'axios';
var md5 = require('md5');
import { Base64 } from 'js-base64';

// import fs from 'fs';

import Vue from 'vue';

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

// import VueCookie from 'vue-cookie';
// Vue.use(VueCookie);

//var FormData = require('form-data');

var api = {
  
    async login(username, password) {

        const api_url = window.__env.api + '/login';
        var sessionId = null;

        return await axios
            .request({
                method: 'post',
                url: api_url,
                withCredentials: true,
                auth: {
                    //username: username,
                    username: Base64.encode(username),
                    password: password ? md5(password).toLowerCase() : ''   // если строка пустая, то передаём её как ''
                    //password: Base64.encode(password)
                },
            })
            .then((response) => {
                const res = response.data.result;

                if (res) {
                    sessionId = res.sessionId;
                    Vue.$cookies.set('sessionId', sessionId, -1);    // -1 - set never expire cookie
                    return { 'result': { userId: res.userId, orgId: res.orgId, fflag: res.fflag }, 'error': response.data.error };
                }
                else {
                    Vue.$cookies.remove('sessionId');
                    return { 'result': null, 'error': response.data.error };
                }
            })
            .catch(function (error) {
                Vue.$cookies.remove('sessionId');
                return { 'result': null, 'error': error.toString() };
            })
    },

    async logoff() {
        const api_url = window.__env.api + '/logoff';
        const sessionId = Vue.$cookies.get('sessionId');

        Vue.$cookies.remove("sessionId");

        return await axios
            .request({
                method: 'post',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async getUserPatterns(id) {
        const api_url = window.__env.api + '/userpatterns';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    id: id
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async getPattern(id) {
        const api_url = window.__env.api + '/pattern';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    id: id
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async getPatternLogo(id) {
        const api_url = window.__env.api + '/patternlogo';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    id: id
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async getPatternFields(id) {
        const api_url = window.__env.api + '/templfields';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    id: id
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async getFideInfo(id) {
        const api_url = window.__env.api + '/fideinfo';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    id: id
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },


    async getPkInfo(id) {
        const api_url = window.__env.api + '/pkinfo';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    id: id
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },
        

    async createCard(userId, patternId, photo, passport, agreement) {
        const api_url = window.__env.api + '/createcard';
        const sessionId = Vue.$cookies.get('sessionId');

        var formData = new FormData();
        formData.append('userId', userId);
        formData.append('patternId', patternId);
        // formData.append('file', photo);
        formData.append('files', photo);
        formData.append('files', passport);
        formData.append('agreement', agreement ? 1 : 0);
  
        return await axios
            .post(
                api_url,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'sessionId': sessionId,
                    },
                })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            });
    },

    async addCardField(cardId, fieldName, fieldValue) {
        const api_url = window.__env.api + '/addcardfield';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'post',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    cardId: cardId,
                    fieldName: fieldName,
                    fieldValue: fieldValue,
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async checkCard(userId, cardId) {
        const api_url = window.__env.api + '/checkcard';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    userId: userId,
                    cardId: cardId,
                }
            })
            .then((response) => {
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    async getFideAPIData(FideID) {
        const api_url = window.__env.proxy;

        return await axios
            .request({
                method: 'get',
                url: api_url,
                params: {
                    id: FideID
                }
            })
            .then((response) => {
                // console.log(response);
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                return { 'result': null, 'error': error.toString() };
            })
    },

    /////////////////////////////////////////////////
/*
    async dictStatus(DictName) {
        const api_url = window.__env.api + '/dict_status';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    dict_name: DictName
                },
            })
            .then((response) => {
                console.log("response then=",response)
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                console.log("response catch=",error)
                return { 'result': null, 'error': error.toString() };
            })
    },
*/    

    async getDictionary(DictName) {
        const api_url = window.__env.api + '/dictionary';
        const sessionId = Vue.$cookies.get('sessionId');
        // DictName: status // passtype  // category  // citizenship // organization // event

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    dict_name: DictName
                },
            })
            .then((response) => {
                // console.log("response then=",response)
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                // console.log("response catch=",error)
                return { 'result': null, 'error': error.toString() };
            })
    },
     


    async getCards(
        P_ID_CARD,
        P_FFLAG,
        P_ID_USER_SELF,
        P_ID_USER,
        P_ID_TTYPE,
        P_ID_TTYPE_CATEGOR,
        P_ID_TTYPE_CITIZEN,
        P_ID_TTYPE_STATUS,
        P_ID_TTYPE_PASS,
        P_ID_ORG,
        P_ID_EVENT,
        P_F,
        P_I,
        P_O,
        P_F_LAT,
        P_I_LAT,
        P_DATE_ACT_1,
        P_DATE_ACT_2,
        P_DATE_BEG_1,
        P_DATE_BEG_2,
        P_DATE_END_1,
        P_DATE_END_2,
        P_DATE_BIRTH_1,
        P_DATE_BIRTH_2,
        P_PASS_DATE_1,
        P_PASS_DATE_2,
        P_PASS_SER,
        P_PASS_NUM,
        P_E_MAIL,
        P_PHONE,
        P_BARCODE,
        P_ID_USER_ACCEPT,
        P_ID_TTYPE_REASON,
        P_RFID,
        P_FANID,
        P_ID_DEP,
        P_ID_EMPL,
        P_ID_TTYPE_KPP,
        P_ID_TTYPE_DEST
    ) {
        const api_url = window.__env.api + '/get_cards';
        const sessionId = Vue.$cookies.get('sessionId');

        return await axios
            .request({
                method: 'get',
                url: api_url,
                withCredentials: true,
                headers: { 'sessionId': sessionId },
                params: {
                    P_ID_CARD:P_ID_CARD,
                    P_FFLAG:P_FFLAG,
                    P_ID_USER_SELF:P_ID_USER_SELF,
                    P_ID_USER:P_ID_USER,
                    P_ID_TTYPE:P_ID_TTYPE,
                    P_ID_TTYPE_CATEGOR:P_ID_TTYPE_CATEGOR,
                    P_ID_TTYPE_CITIZEN:P_ID_TTYPE_CITIZEN,
                    P_ID_TTYPE_STATUS:P_ID_TTYPE_STATUS,
                    P_ID_TTYPE_PASS:P_ID_TTYPE_PASS,
                    P_ID_ORG:P_ID_ORG,
                    P_ID_EVENT:P_ID_EVENT,
                    P_F:P_F,
                    P_I:P_I,
                    P_O:P_O,
                    P_F_LAT:P_F_LAT,
                    P_I_LAT:P_I_LAT,
                    P_DATE_ACT_1:P_DATE_ACT_1,
                    P_DATE_ACT_2:P_DATE_ACT_2,
                    P_DATE_BEG_1:P_DATE_BEG_1,
                    P_DATE_BEG_2:P_DATE_BEG_2,
                    P_DATE_END_1:P_DATE_END_1,
                    P_DATE_END_2:P_DATE_END_2,
                    P_DATE_BIRTH_1:P_DATE_BIRTH_1,
                    P_DATE_BIRTH_2:P_DATE_BIRTH_2,
                    P_PASS_DATE_1:P_PASS_DATE_1,
                    P_PASS_DATE_2:P_PASS_DATE_2,
                    P_PASS_SER:P_PASS_SER,
                    P_PASS_NUM:P_PASS_NUM,
                    P_E_MAIL:P_E_MAIL,
                    P_PHONE:P_PHONE,
                    P_BARCODE:P_BARCODE,
                    P_ID_USER_ACCEPT:P_ID_USER_ACCEPT,
                    P_ID_TTYPE_REASON:P_ID_TTYPE_REASON,
                    P_RFID:P_RFID,
                    P_FANID:P_FANID,
                    P_ID_DEP:P_ID_DEP,
                    P_ID_EMPL:P_ID_EMPL,
                    P_ID_TTYPE_KPP:P_ID_TTYPE_KPP,
                    P_ID_TTYPE_DEST:P_ID_TTYPE_DEST
                },
            })
            .then((response) => {
                // console.log("response then=",response)
                return { 'result': response.data.result, 'error': response.data.error };
            })
            .catch(function (error) {
                // console.log("response catch=",error)
                return { 'result': null, 'error': error.toString() };
            })
    },

}

export default api
